<template>
  <div>
    <!-- 筛选表单 -->
    <a-form layout="inline" class="filter-form">
      <a-row :gutter="24">
        <a-col :md="8" :sm="24">
          <a-form-item>
            <a-select placeholder="选择牧场" v-model="query.farm_id" style="width: 200px;">
              <a-select-option :value="farm.id" v-for="farm in farms" :key="farm.id">{{ farm.name }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md="10" :sm="24">
          <a-form-item>
            <a-range-picker
              v-model="dateRange"
              :show-time="{ format: 'HH:mm:ss' }"
              format="YYYY-MM-DD HH:mm:ss"
              valueFormat="YYYY-MM-DD HH:mm:ss"
              :placeholder="['开始时间', '结束时间']"
              style="width: 100%;"
            />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item>
            <a-button type="primary" @click="handleSearch">查询</a-button>
            <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <a-table 
      :columns="columns"
      :data-source="list"
      :pagination="pagination"
      :row-key="record => record.id"
      @change="handleTableChange"
      @expand="onExpand"
    >
      <div slot="expandedRowRender" slot-scope="record" style="margin: 0" expandIcon="">
        <yu-zhong-chart-result :male_id="record.male_id" :female_id="record.female_id" :ref="`result-${record.male_vid}-${record.female_vid}`"></yu-zhong-chart-result>
      </div>
      <template slot="male_vid" slot-scope="male_id, row">
        <item-button :text="`${row.male_vid}`" :id="row.male_id"></item-button>
      </template>
      <template slot="female_vid" slot-scope="female_id, row">
        <item-button :text="`${row.female_vid}`" :id="row.female_id"></item-button>
      </template>
      <template slot="item_select_record_name" slot-scope="item_select_record_name, row">
        <a-tag v-if="row.item_select_record" class="select-record-tag" @click="goToSelectRecord(row.item_select_record.id)">
          {{ row.item_select_record.name }}
        </a-tag>
        <span v-else>-</span>
      </template>
      <template slot="operation" slot-scope="scope, row">
        <a-dropdown>
          <a-menu slot="overlay" @click="(e) => handleItemAction(e, row)">
            <a-menu-item key="add_offspring"> <a-icon type="plus" />添加后代</a-menu-item>
            <a-menu-item key="remove"> <a-icon type="delete" />移除</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px" size="small"> 操作 <a-icon type="down" /> </a-button>
        </a-dropdown>
      </template>
    </a-table>
    <!-- 添加后代弹窗 -->
    <breed-item-edit ref="breedItemEdit" @finish-edit="onOffspringAdded" />
  </div>
</template>

<script>
import ItemButton from '../../components/ItemButton.vue'
import yuZhongChartResult from './yuZhongChartResult.vue'
import breedItemEdit from '../../breed_items/components/addOrEdit.vue'
export default {
  name: "yuZhongRecordsTable",
  components: {
    ItemButton, yuZhongChartResult, breedItemEdit
  },
  data() {
    return {
      list: [],
      farms: [],
      dateRange: [],
      query: {
        page_no: 1,
        page_size: 20,
        farm_id: undefined,
        start_at: undefined,
        end_at: undefined,
      },
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
        showTotal: total => `共 ${total} 条记录`
      },
      columns: [
        {
          title: "Id",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "雄性供体VId",
          dataIndex: "male_id",
          key: "male_id",
          scopedSlots: {customRender: 'male_vid'}
        },
        {
          title: "雌性供体VId",
          dataIndex: "female_id",
          key: "female_id",
          scopedSlots: {customRender: 'female_vid'}
        },
        {
          title: "选配记录",
          dataIndex: "item_select_record_name",
          key: "item_select_record_name",
          scopedSlots: {customRender: 'item_select_record_name'}
        },
        {
          title: "操作人",
          dataIndex: "user.nickname",
          key: "operator",
        },
        {
          title: "创建时间",
          dataIndex: "created_at",
          key: "created_at",
        },
        {title: '操作', key: 'operation', scopedSlots: { customRender: 'operation' } }
      ]
    }
  },
  async mounted() {
    await this.loadFarms();
    this.refresh_list()
  },
  methods: {
    async refresh_list() {
      try {
        const res = await this.$api.get_yu_zhong_records(this.query);
        this.list = res.list;
        this.pagination.total = res.page.total;
        this.pagination.pageSize = res.page.page_size;
        this.pagination.current = res.page.page_no;
      } catch (error) {
        console.error('获取育种记录失败:', error);
        this.$message.error('获取数据失败');
      }
    },
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.query.page_no = pagination.current
      this.refresh_list()
    },
    async loadFarms() {
      try {
        const res = await this.$api.get_farms({});
        if (res && res.code === 200) {
          this.farms = res.data.list || res.data || [];
        }
      } catch (error) {
        console.error('获取农场列表失败:', error);
        this.$message.error('获取农场列表失败');
      }
    },
    handleItemAction(e, row) {
      if (e.key === 'add_offspring') {
        this.openAddOffspringDialog(row);
      } else if (e.key === 'remove') {
        this.removeRecord(row);
      }
    },
    // 打开添加后代弹窗
    openAddOffspringDialog(row) {
      // 构造预设的父母信息的个体数据
      const presetItem = {
        father_id: row.male_id,
        mother_id: row.female_id,
        item_father: row.male_vid,
        item_mother: row.female_vid,
        farm_id: row.farm_id
      };
      // 调用 addOrEdit 组件的 open 方法，传入预设的父母信息
      this.$refs.breedItemEdit.open('add', presetItem);
    },
    // 后代添加成功回调
    onOffspringAdded() {
      this.$message.success('后代添加成功');
      // 刷新列表
      this.refresh_list();
    },
    // 删除育种记录
    async removeRecord(row) {
      this.$confirm({
        title: '确认删除',
        content: `确定要删除这条育种记录吗？`,
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          try {
            const res = await this.$api.delete_yu_zhong_record(row.id);
            if (res.code === 200) {
              this.$message.success('删除成功');
              this.refresh_list();
            } else {
              this.$message.error(res.message || '删除失败');
            }
          } catch (error) {
            console.error('删除育种记录失败:', error);
            this.$message.error('删除失败');
          }
        }
      });
    },
    goToSelectRecord(id) {
      if (id) {
        this.$router.push(`/farms/cell/${id}?group_type=selectRecord`);
      }
    },
    handleSearch() {
      // 更新时间范围到查询参数
      if (this.dateRange && this.dateRange.length >= 2) {
        this.query.start_at = this.dateRange[0];
        this.query.end_at = this.dateRange[1];
      } else {
        this.query.start_at = undefined;
        this.query.end_at = undefined;
      }
      this.query.page_no = 1;
      this.refresh_list();
    },
    handleReset() {
      this.query.farm_id = undefined;
      this.query.start_at = undefined;
      this.query.end_at = undefined;
      this.dateRange = [];
      this.query.page_no = 1;
      this.refresh_list();
    },
    onExpand(expanded, record) {
      this.$nextTick(() => {
        if (expanded) {
          this.$refs[`result-${record.male_vid}-${record.female_vid}`].draw(record.male_id, record.female_id)
        }
      })
    }
  },
}
</script>

<style scoped>
.filter-form {
  margin-bottom: 20px;
}
.select-record-tag {
  cursor: pointer;
  background: linear-gradient(135deg, #2563EB 0%, #3b82f6 100%);
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 2px 12px;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s ease;
}
.select-record-tag:hover {
  background: linear-gradient(135deg, #1d4ed8 0%, #2563EB 100%);
  opacity: 0.9;
}
</style>